/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { TVehicle, } from "models/inventory/interfaces/vehicle.interface";
import { PandaboardApiInstance } from "../../../helpers/api";
import { VehicleReviewSummary } from "../interfaces/vehicle-review-summary.interfaces";


export const getVehicleReviews = (vehicle: TVehicle, limit?: number): Promise<VehicleReviewSummary | null> =>
  PandaboardApiInstance
    .get(`vehicle-reviews?brand=${vehicle.brand._id}&model=${vehicle.model._id}&cc=${vehicle.cylindersCapacity}&year=${vehicle.year}${limit ? `&limit=${limit}` : ""}`)
    .then((response) => new VehicleReviewSummary(response.data))
    .catch(() => null);
